(function($){
    'use strict';

    /* 
     * Cookie Functions 
     * https://www.w3schools.com/js/js_cookies.asp
     */
    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        var expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }
    function getCookie(cname) {
        var name = cname + '=';
        var ca = document.cookie.split(';');
        for(var i=0; i<ca.length; i = i+1) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length,c.length);
            }
        }
        return '';
    }


    var $systemMessage = $('.system-message').first();
    var systemMessage = getCookie('systemMessage');

    if (systemMessage !== $systemMessage.attr('id') ) {
        $systemMessage.slideDown('slow');
        document.cookie='systemMessage=0';
    }   

    $('.system-message .close').click(function() {
        $systemMessage.slideUp();
        document.cookie='systemMessage=' + $systemMessage.attr('id');
    });



    // $('.icon-navicon').click(function(){
    //     $(this).toggleClass('active');
    //     $('.navbar__toggle').trigger('click');

    //     // if ($('.navbar__dropdown').attr('aria-expanded') === 'true') {
    //     //     $('.navbar__dropdown').slideDown();
    //     // } else {
    //     //     $('.navbar__dropdown').slideUp();
    //     // }

    //     // return false;
    // });


    $.fn.clickToggle = function(func1, func2) {
        var funcs = [func1, func2];
        this.data('toggleclicked', 0);
        this.click(function() {
            var data = $(this).data();
            var tc = data.toggleclicked;
            $.proxy(funcs[tc], this)();
            data.toggleclicked = (tc + 1) % 2;
        });
        return this;
    };

    // Search dropdown (Mobile)
    $('.icon-tools__standard .icon-search').clickToggle(function(){
        $(this).removeClass('icon-search').addClass('icon-close');
        $('.search-wrapper').slideDown();
    }, function() {
        $(this).addClass('icon-search').removeClass('icon-close');
        $('.search-wrapper').slideUp();
    });

    /**
     * NZP-5: Currency Selector
     */
    const currencyDefault = 'AUD';
    
    function displaySelection(currency){
        const clsOptSel = 'currency-selector__option--selected';
        // display it in toolbar
        $('.currency-selector__current .currency-selector__currency').text('$ ' + currency);
        // display it in dropdown
        $('.currency-selector__option').each(function(){
            if ($(this).data('currency') === currency) {
                $(this).addClass(clsOptSel);
            } else {
                $(this).removeClass(clsOptSel);
            }
        });
    }

    function displayCurrencyWarning(show) {
        $('.system-message--currency-warning').toggle(show);
    }

    function displayCurrency(currency) {
        /* globals product */
        try {
            // console.log('displayCurrency: '+ currency);

            // Display in toolbar
            displaySelection(currency);
            
            // Display any NZ pricing on page (see product/js/global.js)
            product.displayPricing(currency);
            
            // Display warning if not default currency
            displayCurrencyWarning(currency !== currencyDefault);
            
        } catch (e) {
            console.error('Error displaying pricing for currency "' + currency + '"', e);
        }
    }

    // Init (on doc ready, when product.displayPricing is defined)
    $(function(){
        let currency = getCookie('currency');
        if (currency) {
            // If a selection has already been made, display it
            displayCurrency(currency);
        }
    });

    // Dropdown 
    $('.currency-selector__select').click(function(e){
        // $(this).removeClass('icon-search').addClass('icon-close');
        $('.currency-selector__dropdown').toggleClass('currency-selector__dropdown--open');
        e.preventDefault();
    });

    // Selected 
    $('.currency-selector__option').click(function(e){
        let currency = $(this).data('currency');

        // Remember selection for one year
        setCookie('currency', currency, 365);
        
        // Display on page
        displayCurrency(currency);

        // If search page, reload search results to show updated pricing
        if ($('#resultset').length) {
            location.search = location.search + '&reload';
        }

        // Hide dropdown
        $('.currency-selector__dropdown').removeClass('currency-selector__dropdown--open');
        
        e.preventDefault(e);
    });

    // Hide when click outside
    // https://stackoverflow.com/a/7385673/421243
    $(document).mouseup(function(e) 
    {
        const $container = $('.currency-selector');

        // if the target of the click isn't the container nor a descendant of the container
        if (!$container.is(e.target) && $container.has(e.target).length === 0) 
        {
            $('.currency-selector__dropdown').removeClass('currency-selector__dropdown--open');
        }
    });

    //Show after initalise to prevent flash of different content
    $('.currency-selector').addClass('currency-selector--initialised'); 

    
}(jQuery));